import MainPage from '@/screens/ouvidoria/MainPage'
import { items } from '@/screens/ouvidoria/config.js'
import ResponderConversa from '@/screens/ouvidoria/ResponderConversa'
import VisualizarConversa from '@/screens/ouvidoria/VisualizarConversa'
import Home from '@/screens/relatorios_ouvidoria/Home'

const ouvidoria = [
  {
    path: '/ouvidoria',
    name: 'ouvidoria',
    component: MainPage,
    children: [...items],
    meta: {
      isPublic: false,
      routeGroup: 'ouvidoria/home'
    }
  },
  {
    path: 'ouvidoria/conversa/responder/:idConversa',
    name: 'ouvidoria/conversa/responder/',
    component: ResponderConversa,
    meta: {
      isPublic: false,
      routeGroup: 'ouvidoria/home'
    }
  },
  {
    path: 'ouvidoria/conversa/visualizar/:idConversa',
    name: 'ouvidoria/conversa/visualizar/',
    component: VisualizarConversa,
    meta: {
      isPublic: false,
      routeGroup: 'ouvidoria/home'
    }
  },
  {
    path: '/ouvidoria/relatorios',
    name: 'ouvidoria/relatorios',
    component: Home,
    redirect: {name: 'ouvidoriaRelatorios'}
  }
]

export default ouvidoria



// WEBPACK FOOTER //
// ./src/router/ouvidoria.js